var _g, _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 570,
    viewBox: "0 0 306 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 567.8C9.93331 566.733 6.33331 563.667 4.19998 560.867L0.333313 555.933V285V14.0667L4.19998 9.13332C11.2666 -0.200014 2.46665 0.33332 153 0.33332C303.533 0.33332 294.733 -0.200014 301.8 9.13332L305.667 14.0667V285V555.933L301.8 560.867C294.733 570.2 303.533 569.667 152.733 569.667C40.8666 569.533 15.5333 569.267 12.2 567.8ZM270.067 453.4L270.333 380.333H153H35.6666V452.867C35.6666 509.667 36.0666 525.533 37.4 526.067C38.2 526.467 90.8667 526.6 154.333 526.467L269.667 526.333L270.067 453.4ZM171.267 210.867C184.467 204.467 191.667 193.533 192.733 178.2C193.533 164.733 190.6 156.467 181.8 147.533C165 130.733 140.333 130.867 124.067 147.8C115.267 157 112.467 165 113.267 178.2C114.067 189 117 195.8 124.333 203.4C136.867 216.333 154.067 219.133 171.267 210.867ZM262.333 55V47H153H43.6666V55V63H153H262.333V55Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6 486.067L51 461H153H255L255.4 486.067L255.667 511H153H50.3333L50.6 486.067Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 420.333V395H153H255.667L255.4 420.067L255 445L152.733 445.4L50.3333 445.667V420.333Z",
    fill: "#2A4E69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.267 197.533C127.133 190.467 123.533 171.4 133.933 158.867C146.067 144.467 169.667 148.6 176.467 166.333C184.733 187.933 162.2 207.8 141.267 197.533Z",
    fill: "#2A4E69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 570,
    fill: "white"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    x: "50%",
    y: "55%",
    alignmentBaseline: "middle",
    textAnchor: "middle",
    fontSize: 100,
    fontWeight: 600,
    fontStyle: "italic"
  }, "\n    WEC\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWec);
export default __webpack_public_path__ + "static/media/wec.98685e117603bb207c89cc2062a32b10.svg";
export { ForwardRef as ReactComponent };